import * as React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { MyContext } from './context/MyContext';
import { useAPI } from './ApiCalls/useAPI';
import { Grid, Nav, RouterContextProvider, Site } from 'tabler-react';
const SANJAYA = '/sanjaya-web';

let psflag = localStorage.getItem('psflag');   

const navBarItems = [
    {
        value: 'Home',
        to: '/',
        icon: 'home',
        LinkComponent: withRouter(NavLink),
        useExact: true
    },   
    // {
    //     value: 'Attendance',
    //     icon: 'check',
    //     to: '/attendance',
    //     LinkComponent: withRouter(NavLink)
    // },
    // {
    //     value: 'TimeTable',
    //     icon: 'clock',
    //     to: '/timetable',
    //     LinkComponent: withRouter(NavLink)
    // },
    {
        value: 'Live Classroom',
        icon: 'play',
        to: '/liveclassroom',
        LinkComponent: withRouter(NavLink)
    },
    // {
    //     value: 'Bus Tracking',
    //     icon: 'navigation',
    //     to: '/bustracking',
    //     LinkComponent: withRouter(NavLink)
    // },
    {
        value: 'Results',
        icon: 'clipboard',
        to: '/results',
        LinkComponent: withRouter(NavLink)
    },
    {
        value: 'Events',
        to: '/events',
        icon: 'calendar',
        LinkComponent: withRouter(NavLink)
    },
    {
        value: 'Student Diary',
        to: '/studentdiary',
        icon: 'book',
        LinkComponent: withRouter(NavLink)
    },
    {
        value: 'Complaints',
        to: '/complaints',
        icon: 'file-text',
        LinkComponent: withRouter(NavLink)
    },
    {
        value: 'Schedule Appointment',
        to: '/appointment',
        icon: 'file-text',
        LinkComponent: withRouter(NavLink)
    },
    {
        value: 'Group Change Request',
        to: '/groupchange',
        icon: 'file-text',
        LinkComponent: withRouter(NavLink)
    }
];

class SiteWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: [],
            NotiCount: 0,
            Depth: '',
            UnAuth: false
        };
    }
    makeApiCalls() {
        const { getProfile, getNotificationsCount } = useAPI();
        getProfile()
            .then((response) => {
                this.setState({
                    userdata: response
                });
            })
            .catch((error) => console.error(error));
        getNotificationsCount()
            .then((response) => {
                if (response.notifications!=="0") {
                    document.getElementById('noticount').style.display = 'block';
                }
                else {
                    document.getElementById('noticount').style.display = 'none';
                }
                this.setState({
                    NotiCount: response.notifications
                });
            })
            .catch((error) => console.error(error));
    }
    componentDidMount() {
        if (this.props.isLoggedIn) {
            this.makeApiCalls();
        }
    }

    componentDidUpdate({ isLoggedIn }) {
        if (isLoggedIn !== this.props.isLoggedIn && this.props.isLoggedIn) {
            this.makeApiCalls();
        }
    }

    static contextType = MyContext;

    render() {
        const { isLoggedIn } = this.context;
        if (!isLoggedIn) return this.props.children;

        return (
            <Site.Wrapper
                headerProps={{
                    href: '/sanjaya-web',
                    alt: 'sanjaya',
                    imageURL: `./images/kmit_sanjaya.png`,
                    navItems: (
                        <Nav.Item
                            type="div"
                            className="d-none d-md-flex"
                        ></Nav.Item>
                    ),
                    accountDropdown: {
                        avatarURL: `${this.state.userdata.picture}`,
                        name: `${this.state.userdata.firstname}`,
                        description: `${this.state.userdata.dept}`,
                        options: [
                            {
                                icon: 'user',
                                value: 'Profile',
                                to: `${SANJAYA}/profile`
                            },
                            {
                                icon: 'edit',
                                value: 'Change Password',
                                to: `${SANJAYA}/changePassword`
                            },
                            {
                                icon: 'settings',
                                value: 'Settings',
                                to: `${SANJAYA}/settings`
                            },
                            {
                                icon: 'log-out',
                                value: 'Sign out',
                                to: `${SANJAYA}/logout_redirect`
                            }
                        ]
                    }
                }}
                navProps={{ itemsObjects: navBarItems }}
                routerContextComponentType={withRouter(RouterContextProvider)}
                footerProps={{
                    copyright: (
                        <React.Fragment>
                            Copyright © 2024
                            <a href="."> sanjaya</a>. Powered by
                            <a
                                href="http://teleparadigm.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {' '}
                                Teleparadigm.
                            </a>{' '}
                            All rights reserved.
                        </React.Fragment>
                    ),
                    nav: (
                        <React.Fragment>
                            <Grid.Col auto={true}></Grid.Col>
                        </React.Fragment>
                    )
                }}
            >
                {this.props.children}
                <div className="noticontainer">
                    <a href={SANJAYA + '/notifications'} className="">
                        <i className="noti fe fe-bell">
                            <div
                                id="noticount"
                                className="topcorner"
                                style={{
                                    display: 'none'
                                }}
                            >
                                {this.state.NotiCount}
                            </div>
                        </i>
                    </a>
                </div>
            </Site.Wrapper>
        );
    }
}

export default SiteWrapper;
